import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TButtonWidget from "../component";
import {EventType, type ExecutionResult} from "../../../constants/AppsmithActionConstants/ActionConstants";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TButton extends TaroWidget<TButtonWidgetProps, WidgetState> {
  constructor(props: TButtonWidgetProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtButtonWidget");
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;
  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.label }}`
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      backgroundColor: "{{appsmith.theme.colors.primaryColor}}",
      color: "{{appsmith.theme.colors.textColor}}",
      boxShadow: "none",
    };
  }
  handleActionComplete = (result: ExecutionResult) => {
    if (result.success) {
      if (this.props.resetFormOnClick && this.props.onReset)
        this.props.onReset();
    }
  };
  onClick(){
    if(this.props.onClick){
      super.executeAction({
        triggerPropertyName: "onClick",
        dynamicString: this.props.onClick,
        event: {
          type: EventType.ON_CLICK,
          callback: this.handleActionComplete
        },
      });
    }else if (this.props.resetFormOnClick && this.props.onReset) {
      this.props.onReset();
    }
  }

  getPageView() {
    const disabled =
      this.props.disabledWhenInvalid &&
      "isFormValid" in this.props &&
      !this.props.isFormValid;
    const isDisabled = this.props.isDisabled || disabled;
    return (
      <TButtonWidget {...this.props} isDisabled={isDisabled} onClick={this.onClick} />
    );
  }


  static getWidgetType(): WidgetType {
    return "AT_BUTTON_WIDGET";
  }
}

export interface TButtonWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TButton;
